import { Dialog, Zoom } from "@mui/material";
import * as PropTypes from "prop-types";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { useTheme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";
import EpmsImage from "@/react/components/Common/EpmsImage";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import useCopyrightDialog from "@/react/Webshop/hooks/useCopyrightDialog";
import useDialogBackButton from "@/react/hooks/useDialogBackButton";
const useStyles = makeStyles((theme) => ({
    fullImage: {
        backgroundColor: "white",
    },
    webshopId: {
        position: "fixed",
        top: theme.spacing(3),
        left: theme.spacing(2),
        color: "rgba(255, 255, 255, 0.8)",
        zIndex: 1,
        fontSize: "14px",
    },
}));
function FullscreenImageDialog({ onClose, open, picture, transformOrigin, actionIcon, actionText, actionHandler, }) {
    const classes = useStyles();
    const theme = useTheme();
    const { getCopyrightTriggerProps, copyrightDialog } = useCopyrightDialog();
    // Let the hardware/browser back button close the image view instead of
    // navigating off the page (e.g. back out to the pre-login screen).
    useDialogBackButton(open, onClose);
    return (React.createElement(Dialog, { open: open, onClose: onClose, PaperProps: {
            style: {
                backgroundColor: "transparent",
                boxShadow: "none",
                borderRadius: 0,
            },
        }, BackdropProps: {
            style: { backgroundColor: alpha(theme.palette.primary.main, 0.9) },
        }, maxWidth: false, keepMounted: true, TransitionComponent: Zoom, TransitionProps: { style: { transformOrigin } } },
        picture && (React.createElement(React.Fragment, null,
            React.createElement(IconButton, { onClick: onClose, sx: {
                    position: "fixed",
                    top: 1,
                    right: 1,
                    color: "common.white",
                    zIndex: 1,
                } },
                React.createElement(CloseIcon, null)),
            React.createElement(Box, { className: classes.webshopId, onClick: onClose },
                "ID: ",
                picture.webshopId),
            React.createElement(EpmsImage
            // Use key even outside 'map' to make sure we get a new instance when
            // the uuid changes. Else, the last picture will "hang"
            // and it will be a delay before it's switched
            , Object.assign({ 
                // Use key even outside 'map' to make sure we get a new instance when
                // the uuid changes. Else, the last picture will "hang"
                // and it will be a delay before it's switched
                key: picture.uuid, size: 800 }, getCopyrightTriggerProps(), { uuid: picture.uuid, onClick: onClose, className: classes.fullImage })),
            actionText && (React.createElement(Button, { variant: "outlined", color: "primary", onClick: () => actionHandler && actionHandler(picture), sx: {
                    color: "common.white",
                    borderColor: "common.white",
                    mt: 2,
                    "&:hover": {
                        color: "common.white",
                        borderColor: "common.white",
                    },
                    "& svg": {
                        mr: 1,
                    },
                } },
                actionIcon && actionIcon,
                actionText)))),
        copyrightDialog));
}
FullscreenImageDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    transformOrigin: PropTypes.string,
    src: PropTypes.string,
};
export default FullscreenImageDialog;
